module.exports = __webpack_public_path__ + "img/a88371b39d966473b84c38acb850d07d.svg";